import { getDirection } from '../../utils'
import { green, amber, blue, blueGrey } from '@material-ui/core/colors'
import RefinitivLogo from '../../images/Refinitiv_st_reg_rgb.png'

export const defaultTheme = {
  color: {
    primary: blueGrey[900],
    secondary: '#eb2714'
  },
  logo: {
    small: '/assets/logo.svg',
    large: RefinitivLogo
  }
}

const clientSettings = JSON.parse(localStorage.getItem('clientSettings'))
const client = clientSettings ? clientSettings : defaultTheme

const theme = {
  direction: getDirection(),
  palette: {
    primary: {
      main: client.color.primary
    },
    secondary: {
      main: client.color.secondary
    },
    warning: {
      main: amber[700]
    },
    info: {
      main: blue[500]
    },
    success: {
      main: green[700]
    },
    type: localStorage.getItem('themeType')
      ? localStorage.getItem('themeType')
      : 'light',
    link: {
      light: '#6a9ae9'
    }
  },
  mixins: {
    toolbarDense: {
      minHeight: 48
    }
  },
  rootSpacing: 20,
  logo: {
    small: client.logo.small,
    large: client.logo.large
  },
  background: {
    login: client.background
  },
  typography: {
    fontFamily: [
      '"Noto Sans"',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(',')
  }
}

export default theme
